import { getClassNameForField, paymentLoadFields as fields } from '../../constants'
import { useTranslationService } from '../../util/TranslationContext'
import { EditableFormPage } from '../components/EditableFormPage'
import { useParams } from 'react-router-dom'

const PaymentLogSlug = () => {
    const { id } = useParams()
    const { translateFields } = useTranslationService()
    const paymentLoadFields = translateFields(fields, 'payment_logs')

    return (
        <>
            <EditableFormPage
                fetchUrl={`admin/payment-logs/${id}`}
                fields={paymentLoadFields}
                classNameForField={getClassNameForField}
                // acceptJSON={true}
                // method='PUT'
                readOnly={true}
            />
        </>
    )
}

export default PaymentLogSlug
